// src/components/onboarding/StepAspiration.js

import React from 'react';
import './Onboarding.css'; 

// Data mapping the domains
const ASPIRATIONS = [
    'Technology & Software',
    'Business & Entrepreneurship',
    'Healthcare & Medical Field',
    'Creative Arts & Design',
    'Content Creation & Media',
    'Sports & Athletic Training',
];

// Props: 
// - value: The currently selected aspiration string (e.g., 'Technology & Software')
// - onChange: Function to update the parent component's state
const StepAspiration = ({ value, onChange }) => {
  return (
    <div className="aspiration-input">
      <p className="input-prompt">Select the industry where you want to build your career.</p>
      <div className="aspiration-options-grid">
        {ASPIRATIONS.map((aspiration) => (
          <button
            key={aspiration}
            className={`btn-tertiary aspiration-btn ${value === aspiration ? 'selected' : ''}`}
            onClick={() => onChange(aspiration)}
          >
            {aspiration}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StepAspiration;